<!--企業預約：選擇健檢方案-->
<div class="page-container reserve-business-content">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">
      {{ 'business-reserve-result.title' | translate }}
    </h2>
  </div>

  <div class="card-content register-card-content">
    <div class="confirm-header">
      <h3 class="register-card-title">
        {{ 'business-reserve-result.company-name' | translate }}
        {{ companyInfo?.companyName }}
      </h3>

      @if (this.sharedStorageService.get('modifyType') !== 'modifyExam') {
        <div class="location-block">
          <p class="confirm-header-title">
            {{ 'business-reserve-result.select-currently' | translate }}
          </p>
          <mat-form-field appearance="fill">
            <mat-select
              [(ngModel)]="selectedLocation"
              (ngModelChange)="selectLocation()"
            >
              @for (location of locations; track location.orgNo) {
                <mat-option [value]="location.orgNo">{{
                  location.orgName
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    <div class="confirm-body">
      @if (companyInfo?.bookableDateE) {
      <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'business-reserve-result.reserve-due-date' | translate }}
        </p>
        <p>{{ formattedDueDate }}</p>
      </div>
    }
      @if (hasSponsorAmount) {
        <div class="confirm-body-item">
        <p class="confirm-body-item-title">
          {{ 'business-reserve-result.subsidy-amount' | translate }}
        </p>
        <p><label>$</label>{{ sponsorAmt | numberComma }}</p>
      </div>
      }
    </div>
  </div>

  <div class="business-package-container">
    @if (isLoadingPackages) {
      <div class="loading-container">
        <span>載入方案中...</span>
      </div>
    } @else {
      @for (packageDetail of visiblePackages; track packageDetail.packageNo) {
        <div class="btn-card">
          <p class="btn-card-title">{{ packageDetail.packageName }}</p>
          <p class="btn-card-price">
            <label>$</label>{{ packageDetail.price | numberComma }}
          </p>
          <div class="btn-group">
            <button
              mat-button
              class="btn-outline-primary btn-size-l"
              (click)="viewPackage(packageDetail)"
            >
              {{ 'business-reserve-result.view-package' | translate }}
            </button>
            <button
              mat-button
              class="btn-fill-primary btn-size-l"
              (click)="selectPackage(packageDetail)"
            >
              {{ 'business-reserve-result.select-package' | translate }}
            </button>
          </div>
        </div>
      }
      
      <!-- 懶加載觸發器 -->
      @if (hasMorePackages) {
        <div #loadMoreTrigger class="load-more-trigger"></div>
      }
    }
  </div>
</div>
